import React from 'react';
import Home from './Home';
import ChatWidget from './components/ChatWidget';
import './index.css';

function App() {
  return (
    <div className="App">
      <Home />
      <ChatWidget />
    </div>
  );
}

export default App;